import {
    SvgIcon as MuiSvgIcon,
    SvgIconProps as MuiSvgIconProps
} from '@mui/material';
import * as React from 'react';

import { Icon, IconProps } from './base-icon';

const IconMysportsSvg = (props: MuiSvgIconProps) => {
    return (
        <MuiSvgIcon {...props} viewBox="0 0 24 24">
            <path d="M14 22C14 23.1 13.1 24 12 24C10.9 24 10 23.1 10 22C10 20.9 10.9 20 12 20C13.1 20 14 20.9 14 22ZM7 15C5.9 15 5 15.9 5 17C5 18.1 5.9 19 7 19C8.1 19 9 18.1 9 17C9 15.9 8.1 15 7 15ZM12 15C10.9 15 10 15.9 10 17C10 18.1 10.9 19 12 19C13.1 19 14 18.1 14 17C14 15.9 13.1 15 12 15ZM17 15C15.9 15 15 15.9 15 17C15 18.1 15.9 19 17 19C18.1 19 19 18.1 19 17C19 15.9 18.1 15 17 15ZM7 10C5.9 10 5 10.9 5 12C5 13.1 5.9 14 7 14C8.1 14 9 13.1 9 12C9 10.9 8.1 10 7 10ZM2 10C0.9 10 0 10.9 0 12C0 13.1 0.9 14 2 14C3.1 14 4 13.1 4 12C4 10.9 3.1 10 2 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM17 10C15.9 10 15 10.9 15 12C15 13.1 15.9 14 17 14C18.1 14 19 13.1 19 12C19 10.9 18.1 10 17 10ZM22 10C20.9 10 20 10.9 20 12C20 13.1 20.9 14 22 14C23.1 14 24 13.1 24 12C24 10.9 23.1 10 22 10ZM7 5C5.9 5 5 5.9 5 7C5 8.1 5.9 9 7 9C8.1 9 9 8.1 9 7C9 5.9 8.1 5 7 5ZM7 0C5.9 0 5 0.9 5 2C5 3.1 5.9 4 7 4C8.1 4 9 3.1 9 2C9 0.9 8.1 0 7 0ZM2 5C0.9 5 0 5.9 0 7C0 8.1 0.9 9 2 9C3.1 9 4 8.1 4 7C4 5.9 3.1 5 2 5ZM12 5C10.9 5 10 5.9 10 7C10 8.1 10.9 9 12 9C13.1 9 14 8.1 14 7C14 5.9 13.1 5 12 5ZM17 5C15.9 5 15 5.9 15 7C15 8.1 15.9 9 17 9C18.1 9 19 8.1 19 7C19 5.9 18.1 5 17 5ZM17 0C15.9 0 15 0.9 15 2C15 3.1 15.9 4 17 4C18.1 4 19 3.1 19 2C19 0.9 18.1 0 17 0ZM22 5C20.9 5 20 5.9 20 7C20 8.1 20.9 9 22 9C23.1 9 24 8.1 24 7C24 5.9 23.1 5 22 5Z" />
        </MuiSvgIcon>
    );
};

export const IconMysports = (props: IconProps) => {
    return (
        <Icon
            iconComponent={IconMysportsSvg}
            outlineComponent={IconMysportsSvg}
            roundedComponent={IconMysportsSvg}
            {...props}
        />
    );
};

const IconAIHelpSvg = (props: MuiSvgIconProps) => {
    return (
        <MuiSvgIcon {...props} viewBox="0 0 14 14">
            <g>
                <path d="M13.0782 3.33862L10.6648 0.925313C10.4391 0.699608 10.144 0.583862 9.84884 0.583862C9.55369 0.583862 9.25854 0.699608 9.03283 0.925313L0.583374 9.36319V12.8356C0.583374 13.1539 0.843802 13.4143 1.1621 13.4143H4.63448L13.0782 4.97063C13.5296 4.51922 13.5296 3.78424 13.0782 3.33283V3.33862ZM2.09965 9.48473L8.44253 3.13606L10.8558 5.54936L4.51295 11.8922L2.09965 9.47894V9.48473ZM1.74083 10.7637L3.23974 12.2626H1.74083V10.7637ZM11.6776 4.73914L9.26432 2.32584L9.84305 1.74711L12.2564 4.16041L11.6776 4.73914Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.5718 1.57174L2.09574 0H2.57095L3.09489 1.57174L4.66667 2.09565V2.57084L3.09489 3.09476L2.57095 4.6665H2.09574L1.5718 3.09476L0 2.57084V2.09565L1.5718 1.57174Z"
                />
            </g>
        </MuiSvgIcon>
    );
};

export const IconAIhelp = (props: IconProps) => {
    return (
        <Icon
            iconComponent={IconAIHelpSvg}
            outlineComponent={IconAIHelpSvg}
            roundedComponent={IconAIHelpSvg}
            {...props}
        />
    );
};

const IconPredictionAISvg = (props: MuiSvgIconProps) => {
    return (
        <MuiSvgIcon {...props} viewBox="0 0 22 22">
            <g id="Group">
                <g id="Group_2">
                    <path
                        id="Vector"
                        d="M17.4167 8.24984L18.5625 5.729L21.0833 4.58317L18.5625 3.43734L17.4167 0.916504L16.2708 3.43734L13.75 4.58317L16.2708 5.729L17.4167 8.24984Z"
                    />
                    <path
                        id="Vector_2"
                        d="M17.4167 13.75L16.2708 16.2708L13.75 17.4167L16.2708 18.5625L17.4167 21.0833L18.5625 18.5625L21.0833 17.4167L18.5625 16.2708L17.4167 13.75Z"
                    />
                    <path
                        id="Vector_3"
                        d="M10.5416 8.70817L8.24996 3.6665L5.95829 8.70817L0.916626 10.9998L5.95829 13.2915L8.24996 18.3332L10.5416 13.2915L15.5833 10.9998L10.5416 8.70817ZM9.15746 11.9073L8.24996 13.9057L7.34246 11.9073L5.34413 10.9998L7.34246 10.0923L8.24996 8.094L9.15746 10.0923L11.1558 10.9998L9.15746 11.9073Z"
                    />
                </g>
            </g>
        </MuiSvgIcon>
    );
};

export const IconPredictionAI = (props: IconProps) => {
    return (
        <Icon
            iconComponent={IconPredictionAISvg}
            outlineComponent={IconPredictionAISvg}
            roundedComponent={IconPredictionAISvg}
            {...props}
        />
    );
};

const IconMicrosoftSvg = (props: MuiSvgIconProps) => {
    return (
        <MuiSvgIcon {...props} viewBox="0 0 32 32">
            <rect x="17" y="17" width="10" height="10" fill="#FEBA08" />
            <rect x="5" y="17" width="10" height="10" fill="#05A6F0" />
            <rect x="17" y="5" width="10" height="10" fill="#80BC06" />
            <rect x="5" y="5" width="10" height="10" fill="#F25325" />
        </MuiSvgIcon>
    );
};

export const IconMicrosoft = (props: IconProps) => {
    return (
        <Icon
            iconComponent={IconMicrosoftSvg}
            outlineComponent={IconMicrosoftSvg}
            roundedComponent={IconMicrosoftSvg}
            {...props}
        />
    );
};

const IconGoogleSvg = (props: MuiSvgIconProps) => {
    return (
        <MuiSvgIcon {...props} viewBox="0 0 48 48">
            <path
                fill="#FFC107"
                d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"
            />
            <path
                fill="#FF3D00"
                d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"
            />
            <path
                fill="#4CAF50"
                d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"
            />
            <path
                fill="#1976D2"
                d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"
            />
        </MuiSvgIcon>
    );
};

export const IconGoogle = (props: IconProps) => {
    return (
        <Icon
            iconComponent={IconGoogleSvg}
            outlineComponent={IconGoogleSvg}
            roundedComponent={IconGoogleSvg}
            {...props}
        />
    );
};

const IconOktaSvg = (props: MuiSvgIconProps) => {
    return (
        <MuiSvgIcon {...props} viewBox="0 0 36 36">
            <path d="m19.8.26-.74 9.12c-.35-.04-.7-.06-1.06-.06-.45 0-.89.03-1.32.1L16.26 5c-.01-.14.1-.26.24-.26h.75L16.89.27c-.01-.14.1-.26.23-.26h2.45c.14 0 .25.12.23.26Zm-6.18.45c-.04-.13-.18-.21-.31-.16l-2.3.84c-.13.05-.19.2-.13.32l1.87 4.08-.71.26c-.13.05-.19.2-.13.32l1.91 4.01c.69-.38 1.44-.67 2.23-.85L13.63.71ZM7.98 3.25l5.29 7.46c-.67.44-1.28.96-1.8 1.56L8.3 9.15c-.1-.1-.09-.26.01-.35l.58-.48-3.15-3.19c-.1-.1-.09-.26.02-.35l1.87-1.57c.11-.09.26-.07.34.04ZM3.54 7.57c-.11-.08-.27-.04-.34.08L1.98 9.77c-.07.12-.02.27.1.33l4.06 1.92-.38.65a.23.23 0 0 0 .11.33l4.04 1.85c.29-.75.68-1.45 1.16-2.08zM.55 13.33c.02-.14.16-.22.29-.19l8.85 2.31c-.23.75-.36 1.54-.38 2.36l-4.43-.36a.23.23 0 0 1-.21-.28l.13-.74-4.47-.42c-.14-.01-.23-.14-.21-.28l.42-2.41Zm-.33 5.98c-.14.01-.23.14-.21.28L.44 22c.02.14.16.22.29.19l4.34-1.13.13.74c.02.14.16.22.29.19l4.28-1.18c-.25-.74-.41-1.53-.45-2.34l-9.11.84Zm1.42 6.34a.236.236 0 0 1 .1-.33L10 21.4c.31.74.73 1.43 1.23 2.05l-3.62 2.58c-.11.08-.27.05-.34-.07l-.38-.66-3.69 2.55c-.11.08-.27.04-.34-.08l-1.23-2.12Zm10.01-1.72-6.43 6.51c-.1.1-.09.26.02.35l1.88 1.57c.11.09.26.07.34-.04l2.6-3.66.58.49c.11.09.27.07.35-.05l2.52-3.66c-.68-.42-1.31-.93-1.85-1.51Zm-1.27 10.45a.234.234 0 0 1-.13-.32l3.81-8.32c.7.36 1.46.63 2.25.78l-1.12 4.3c-.03.13-.18.21-.31.16l-.71-.26-1.19 4.33c-.04.13-.18.21-.31.16l-2.3-.84Zm6.56-7.75-.74 9.12c-.01.14.1.26.23.26h2.45c.14 0 .25-.12.23-.26l-.36-4.47h.75c.14 0 .25-.12.24-.26l-.42-4.42c-.43.07-.87.1-1.32.1-.36 0-.71-.02-1.06-.07m8.82-24.69c.06-.13 0-.27-.13-.32l-2.3-.84c-.13-.05-.27.03-.31.16l-1.19 4.33-.71-.26c-.13-.05-.27.03-.31.16l-1.12 4.3c.8.16 1.55.43 2.25.78zm5.02 3.63-6.43 6.51a8.7 8.7 0 0 0-1.85-1.51l2.52-3.66c.08-.11.24-.14.35-.05l.58.49 2.6-3.66c.08-.11.24-.13.34-.04l1.88 1.57c.11.09.11.25.02.35Zm3.48 5.12c.13-.06.17-.21.1-.33l-1.23-2.12a.246.246 0 0 0-.34-.08l-3.69 2.55-.38-.65c-.07-.12-.23-.16-.34-.07l-3.62 2.58c.5.62.91 1.31 1.23 2.05l8.26-3.92Zm1.3 3.32.42 2.41c.02.14-.07.26-.21.28l-9.11.85c-.04-.82-.2-1.6-.45-2.34l4.28-1.18c.13-.04.27.05.29.19l.13.74 4.34-1.13c.13-.03.27.05.29.19Zm-.41 8.85c.13.03.27-.05.29-.19l.42-2.41a.24.24 0 0 0-.21-.28l-4.47-.42.13-.74a.24.24 0 0 0-.21-.28l-4.43-.36c-.02.82-.15 1.61-.38 2.36l8.85 2.31Zm-2.36 5.5c-.07.12-.23.15-.34.08l-7.53-5.2c.48-.63.87-1.33 1.16-2.08l4.04 1.85c.13.06.18.21.11.33l-.38.65 4.06 1.92c.12.06.17.21.1.33zm-10.07-3.07 5.29 7.46c.08.11.24.13.34.04l1.87-1.57c.11-.09.11-.25.02-.35l-3.15-3.19.58-.48c.11-.09.11-.25.01-.35l-3.17-3.12c-.53.6-1.13 1.13-1.8 1.56Zm-.05 10.16c-.13.05-.27-.03-.31-.16l-2.42-8.82c.79-.18 1.54-.47 2.23-.85l1.91 4.01c.06.13 0 .28-.13.32l-.71.26 1.87 4.08c.06.13 0 .27-.13.32l-2.3.84Z" />
        </MuiSvgIcon>
    );
};

export const IconOkta = (props: IconProps) => {
    return (
        <Icon
            iconComponent={IconOktaSvg}
            outlineComponent={IconOktaSvg}
            roundedComponent={IconOktaSvg}
            {...props}
        />
    );
};
